const roles = {
    admin: 'admin',
    user: 'user'
}

export default roles;